import React, { Fragment } from "react";

// helpers
import states from "../../helpers/states";
import {
  nameRegex,
  addressRegex,
  cityRegex,
  zipRegex,
  emailRegex,
  phoneRegex,
} from "../../helpers/regex";

const ClassyDonateContactInfo = ({ register, errors }) => {
  return (
    <fieldset className="ClassyDonate-form-contact">
      <legend className="c-violet-dark">Contact information</legend>

      <div className="ClassyDonate-form-twoUp u-mb2">
        <div>
          <label htmlFor="firstName">
            First name*
            {errors.firstName && errors.firstName.type === "required" && (
              <span data-validate="error">Please provide your first name.</span>
            )}
            {errors.firstName && errors.firstName.type === "maxLength" && (
              <span data-validate="error">
                Can only be a maximum of 50 characters
              </span>
            )}
            {errors.firstName && errors.firstName.type === "pattern" && (
              <span data-validate="error">Please provide a valid name.</span>
            )}
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            ref={register({
              required: true,
              maxLength: 50,
              pattern: nameRegex,
            })}
          />
        </div>

        <div>
          <label htmlFor="lastName">
            Last name*
            {errors.lastName && errors.lastName.type === "required" && (
              <span data-validate="error">Please provide your last name.</span>
            )}
            {errors.lastName && errors.lastName.type === "maxLength" && (
              <span data-validate="error">
                Can only be a maximum of 50 characters
              </span>
            )}
            {errors.lastName && errors.lastName.type === "pattern" && (
              <span data-validate="error">Please provide a valid name.</span>
            )}
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            ref={register({
              required: true,
              maxLength: 50,
              pattern: nameRegex,
            })}
          />
        </div>
      </div>

      <div className="u-mb2">
        <label htmlFor="email">
          Email*
          {errors.email && errors.email.type === "required" && (
            <span data-validate="error">Please provide a valid email.</span>
          )}
          {errors.email && errors.email.type === "pattern" && (
            <span data-validate="error">Please provide a valid email.</span>
          )}
          {errors.email && errors.email.type === "maxLength" && (
            <span data-validate="error">
              Must be less than or equal to 100 characters.
            </span>
          )}
          {errors.email && errors.email.type === "matching" && (
            <span data-validate="error">Doesn't match</span>
          )}
        </label>
        <input
          type="text"
          inputMode="email"
          id="email"
          name="email"
          maxLength="100"
          placeholder="Enter email address"
          ref={register({
            pattern: emailRegex,
            maxLength: 100,
            required: true,
          })}
        />
      </div>

      <div className="u-mb2">
        <label htmlFor="address">
          Billing address*
          {errors.address && errors.address.type === "required" && (
            <span data-validate="error">Please provide an address</span>
          )}
          {errors.address && errors.address.type === "pattern" && (
            <span data-validate="error">Please provide a valid address</span>
          )}
          {errors.address && errors.address.type === "maxLength" && (
            <span data-validate="error">
              Must be less than or equal to 50 characters.
            </span>
          )}
        </label>
        <input
          type="text"
          id="address"
          name="address"
          placeholder="123 Main Street, Apt. 2"
          maxLength="50"
          ref={register({
            required: true,
            pattern: addressRegex,
            maxLength: 50,
          })}
        />
      </div>

      <div className="ClassyDonate-form-twoUp u-mb2">
        <div>
          <label htmlFor="city">
            City*
            {errors.city && errors.city.type === "required" && (
              <span data-validate="error">Please provide a city</span>
            )}
            {errors.city && errors.city.type === "pattern" && (
              <span data-validate="error">
                Please provide a valid city name
              </span>
            )}
            {errors.city && errors.city.type === "maxLength" && (
              <span data-validate="error">
                Must be less than or equal to 50 characters.
              </span>
            )}
          </label>
          <input
            type="text"
            id="city"
            name="city"
            placeholder="City"
            maxLength="50"
            ref={register({
              required: true,
              pattern: cityRegex,
              maxLength: 50,
            })}
          />
        </div>

        <div>
          <label htmlFor="state">
            State*
            {errors.state && errors.state.type === "required" && (
              <span data-validate="error">Please select a state</span>
            )}
          </label>
          <select name="state" id="state" ref={register({ required: true })}>
            <option value="">Select</option>
            {states.map((state, i) => (
              <option key={i} value={state.abbr}>
                {state.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="ClassyDonate-form-twoUp u-mb2">
        <div>
          <label htmlFor="zip">
            ZIP/Postal code*
            {errors.zip && errors.zip.type === "required" && (
              <span data-validate="error">Please provide your ZIP Code</span>
            )}
            {errors.zip && errors.zip.type === "pattern" && (
              <span data-validate="error">Must be a 5-digit ZIP Code</span>
            )}
          </label>
          <input
            type="text"
            id="zip"
            name="zip"
            placeholder="5-digit ZIP"
            maxLength="5"
            ref={register({ required: true, pattern: zipRegex })}
          />
        </div>
        <div>
          <label htmlFor="phone">
            Phone*
            {errors.phone && errors.phone.type === "required" && (
              <span data-validate="error">
                Please provide your phone number.
              </span>
            )}
            {errors.phone && errors.phone.type === "pattern" && (
              <span data-validate="error">
                Must be a 10 digit phone number. Do not include spaces,
                parenthesis, or dashes.
              </span>
            )}
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            inputMode="numeric"
            maxLength="10"
            placeholder="Enter phone number"
            ref={register({ required: true, pattern: phoneRegex })}
          />
        </div>
      </div>
    </fieldset>
  );
};

export default ClassyDonateContactInfo;
